import React,{useState} from 'react'

function HomeItem(p) {
    const [disp,setDisp]=useState({display:"none"});
    const [text,setText]=useState("Show")
    const [cardHeight,setHeight]=useState({width: "18rem",height:"17rem"})
    const show=()=>{
        if(text==="Show"){
            setDisp({display:"block"})
            setHeight({width: "18rem",height:"auto"})
            setText("Hide")
        }else{
            setDisp({display:"none"})
            setText("Show")
            setHeight({width: "18rem",height:"17rem"})
        }
        
    }
  return (
    <div>
    <div className="card my-3" style={cardHeight} >
  <img  className="card-img-top" src={p.img} alt="Market need" style={{height:"10rem"}}/>
  <h5 className="card-title" >{p.about}</h5>
  <button type="button" class="btn btn-primary" onClick={show}>{text} Full Details</button>
  <div className="card-body">
    <p className="card-text" style={disp}>{p.body}</p>
  </div>
</div>
    </div>
  )
}

export default HomeItem
